import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import useCrmObjectTypeListingFilters from './useCrmObjectTypeListingFilters';
export function useFilterGroups() {
  "use memo";

  const $ = _c(2);
  const {
    filters
  } = useCrmObjectTypeListingFilters();
  let t0;
  if ($[0] !== filters.filterGroups) {
    t0 = filters.filterGroups || [];
    $[0] = filters.filterGroups;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useFilterQuery() {
  "use memo";

  const {
    filters
  } = useCrmObjectTypeListingFilters();
  return filters.query;
}
export function useSortState() {
  "use memo";

  const {
    filters
  } = useCrmObjectTypeListingFilters();
  return filters.sort;
}
export function useHiddenFilter() {
  "use memo";

  const $ = _c(2);
  const {
    hiddenFilter
  } = useCrmObjectTypeListingFilters();
  let t0;
  if ($[0] !== hiddenFilter) {
    t0 = hiddenFilter || {
      filterGroups: [{
        filters: []
      }]
    };
    $[0] = hiddenFilter;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}